<template>
	<div>
		<div class="row">
			<div class="col-xs-12">

			<h1 class="page-header">{{ pageTitle }}

				<span class="pull-right">
                <button v-on:click="createNewWorkout" class="btn btn-primary" v-show="!showForm">Add New Workout</button>
                <button v-on:click="cancelEditing" class="btn btn-danger" v-show="showForm">Cancel</button>
                <button v-on:click="saveWorkout" class="btn btn-success" v-show="showForm">Save Workout</button>
            </span>
			</h1>
			</div>
		</div>

		<div class="row">
			<workout-form v-on:workout-edit-cancelled="cancelEditing" v-on:workout-updated="finishEditing" v-show="showForm" ref="workoutForm"></workout-form>
		</div>

		<workout-list v-on:edit-workout="editWorkout" v-show="!showForm" ref="workoutList" :filterOwnerId="filterOwnerId" :owners="owners"></workout-list>
	</div>
</template>


<script>
export default {
	props: {
		// HTML is case insensitive. Vue converts kebab-case HTML props to camel-case
		// So in HTML this is page-title
		pageTitle: {
			type: String,
			default: 'Workouts'
		},
		filterOwnerId: {
			type: Number,
			default: null
		},
		owners: {
			type: Object,
			default: null
		}
	},
	data: function () {
		return {
			showForm: false,
		}
	},
	computed: {
	},
	mounted() {
		this.debug('component mounted.');
	},
	methods: {
		editWorkout(workout_id, workout) {
			this.debug('editWorkout()');
			this.$refs.workoutForm.setWorkoutData(workout_id, workout);
			this.showForm = true;
		},
		createNewWorkout() {
			this.debug('createNewWorkout()');
			this.$refs.workoutForm.loadEmptyWorkout();
			this.showForm = true;
		},
		saveWorkout() {
			this.debug('saveWorkout()');
			this.$refs.workoutForm.saveWorkout();
		},
		finishEditing() {
			this.debug('finishEditing()');
			this.showForm = false;
			this.$refs.workoutList.loadWorkouts();
		},
		cancelEditing() {
			this.debug('cancelEditing()');
			this.showForm = false;
		},
		debug(message) {
			console.log('WorkoutsPage: ' + message);
		},

	}
}
</script>